import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import Calculators from './Calculators';
import Banner from './Banner';


export default function Home() {
  return (
    <>
    <main>
        <Navbar />
        <HeroSection />
        <Banner />
        <Calculators />
    </main>
    <Footer />
    </>
  )
}
